import { ScreenOrientation } from "features/creator/types";

export const SCREEN_SIZE = {
  // visible area based on 1280x960 size
  [ScreenOrientation.LANDSCAPE]: {
    WIDTH: 1024,
    HEIGHT: 768,
  },
  [ScreenOrientation.PORTRAIT]: {
    WIDTH: 1024,
    HEIGHT: 768,
  },
};
export const DEFAULT_SCREEN_ORIENTATION = ScreenOrientation.LANDSCAPE; // orientation: "portrait"(縦) | "landscape"(横)
export const INITIAL_SCREEN_CANVAS_SCALE = 1;
export const SCREEN_CANVAS_SCALE_MAX = 1.5;
export const SCREEN_CANVAS_SCALE_MIN = 0.1;
export const MAX_SCREENS = 5;
export const MAX_PROJECTS = 10;
// undo / redo の回数（ピースビルダーと同じ。docs/edit-history-undo.md）
export const HISTORY_STACK_MAX = 50;
// エディタを開いたまま区切りを残す間隔（docs/edit-history-undo.md）
export const AUTO_VERSION_INTERVAL_MS = 10 * 60 * 1000;
